import { createFileRoute } from "@tanstack/react-router";
import EnvFormatterPage from "@/pages/EnvFormatterPage";

export const Route = createFileRoute("/tools/env-formatter")({
  component: EnvFormatterPage,
});
